<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/Resumen">Resumen de Proceso</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Resumen de Proceso</span>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecha1" id="fecha1" placeholder="Desde" v-on:click=usuario() v-model="fecha1" required>
             <input type="date" name="fecha2" id="fecha2" placeholder="Hasta" v-model="fecha2" required>
             <input type="hidden" name="serie" id="serie" placeholder="Serie" @blur="validarCanal" v-model="serie">
            <input type="hidden" v-model="value" name="canal" id="canal" placeholder="Número de canal"  pattern=".{3,10}" @blur="validarCanal" >
            <input type="hidden" id="peso" name="peso" placeholder="Peso"  pattern="[0-9]+([\.,][0-9]+)?" step="0.01" >
             
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        <input type="submit" value="Mostrar Datos" :class="boton">
                           
        </div>
            </form>

            <span class="card-title"><h4>Resumen de Proceso del {{fecha1}} al {{fecha2}}</h4></span>
          <form id="formResumen" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
          <b-card-text><h5>
          Total de bovinos sacrificados: {{formEditar.total}}. <br>
          Total de porcinos sacrificados: {{totalCerdos.total}}. </h5>
        </b-card-text>
          
           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        
                           
        </div>
            </form>
       

    <b-card-body class="text-center">
     

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajaxdelay() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     :line-numbers="true"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       
       <b-button variant='danger'>Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarPesosBovinos from '../mixins/eliminarPesosBovinos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'Resumen',  
  data () {
    return {
        value:1,
         boton:'btn blue',
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        corregir:'',
        canal:'',
        serie:'',
        totalCerdos:{},
        formEditar:{},
      columns:[
        {
          label:'Folio',
          field:'canal'
        },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Peso',
          field:'peso'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
     ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    validarCanal(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarCanal.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='El canal indicado ya está registrado'
                            swal({
                    title:'El canal indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                  
                    
                })
                   
        },

     onCellClick(params) {
         if(params.column.field=="eliminar"){
         this.eliminarPesosBovinos(params.row.id)
         this.ajax()
         }
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajaxdelay(){
     setTimeout(() => {  this.ajax(); }, 2500)
    },
    ajax(){
     
     const desde = this.fecha1
     const hasta=this.fecha2
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBovinosResumen.php?fecha1='+desde+'&fecha2='+hasta+'&unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    this.validarCanal()
    },
    editar(){
      
            //this.usuario()
             const desde=this.fecha1
           const hasta=this.fecha2
           const unidadlocal=this.unidad
           
          axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getResumen.php?fecha1='+desde+'&fecha2='+hasta+'&unidad='+unidadlocal)
                
                   
                .then(response=>{
                   
                    this.formEditar = response.data
                  //swal(this.formEditar.total)
                   
                })

                axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getResumenPorcinos.php?fecha1='+desde+'&fecha2='+hasta+'&unidad='+unidadlocal)
                
                   
                .then(response=>{
                   
                    this.totalCerdos = response.data
                  //swal(this.formEditar.total)
                   
                })
            
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarPesosBovinos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Resumen.vue